import { useLocationSelector } from 'src/hooks/router/useLocation';

export const useIsOnboarding = () => {
  return useLocationSelector(location => location.state?.isOnboarding);
};
